import { SOFTWARE_PAGE_VIEWED_COOKIE } from 'constants/cookies';
import Cookies from 'js-cookie';

export const getSoftwarePageViewed = () => {
  const cookieValue = Cookies.get(SOFTWARE_PAGE_VIEWED_COOKIE);
  return cookieValue === 'true';
};
